export default __webpack_public_path__ + "static/slika4-a2d467373643e42f1ae97fc45914aead.jpg";